import { MenuItemType } from './index'

//* Portal do Cliente: o cliente vê os documentos que o escritório disponibiliza e envia os seus
const CLIENT: MenuItemType[] = [
  { key: 'vilacon', label: 'Vila Contábil', isTitle: true },
  {
    key: 'docs',
    label: 'Documentos',
    icon: 'fa-regular fa-folder-open',
    children: [
      {
        key: 'clientDocs',
        label: 'Meus documentos',
        url: '/cliente/documents',
      },
    ],
  },
];

export default CLIENT
